import { render, staticRenderFns } from "./InDmMedia.vue?vue&type=template&id=8fa73a1e&scoped=true"
import script from "./InDmMedia.vue?vue&type=script&setup=true&lang=ts"
export * from "./InDmMedia.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InDmMedia.vue?vue&type=style&index=0&id=8fa73a1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa73a1e",
  null
  
)

export default component.exports